export default __webpack_public_path__ + "static/media/tt.eb179e85.png";